import classNames from 'classnames';
import { Facebook } from 'components/gruenland/icons/Facebook';
import { Instagram } from 'components/gruenland/icons/Instagram';
import Link from 'next/link';

type Props = {
  className?: string;
};
export const SocialLinkIcons: React.FC<Props> = ({ className }) => {
  return (
    <div className={classNames('flex items-center gap-6 text-white', className)}>
      <Link href="https://www.facebook.com/Grunland" target="_blank">
        <Facebook />
      </Link>
      <Link href="https://www.instagram.com/grunlandshoes/" target="_blank">
        <Instagram />
      </Link>
    </div>
  );
};
